import SignUp from "./SignUp.container";

export default SignUp;
